"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalContainer = _interopRequireDefault(require("./ModalContainer"));

var _ModalHeading = _interopRequireDefault(require("./ModalHeading"));

var _ModalFooter = _interopRequireDefault(require("./ModalFooter"));

var _ModalContent = _interopRequireDefault(require("./ModalContent"));

var _ModalClose = _interopRequireDefault(require("./ModalClose"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Modal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Modal, _PureComponent);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = _super.call(this, props);
    _this.ctaButtonRef = /*#__PURE__*/_react.default.createRef();
    _this.onAfterOpen = _this.onAfterOpen.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "onAfterOpen",
    value: function onAfterOpen() {
      this.ctaButtonRef.current.focusCtaButton();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelText = _this$props.cancelText,
          children = _this$props.children,
          confirmText = _this$props.confirmText,
          description = _this$props.description,
          isWorking = _this$props.isWorking,
          name = _this$props.name,
          onCancel = _this$props.onCancel,
          onClose = _this$props.onClose,
          onConfirm = _this$props.onConfirm,
          variant = _this$props.variant,
          titleText = _this$props.titleText; // https://github.com/reactjs/react-modal/blob/master/docs/README.md

      return /*#__PURE__*/_react.default.createElement(_ModalContainer.default, this.props, /*#__PURE__*/_react.default.createElement(_ModalHeading.default, {
        id: "modalTitle-".concat(name),
        variant: variant,
        titleText: titleText
      }), /*#__PURE__*/_react.default.createElement(_ModalContent.default, {
        id: "modalContent-".concat(name)
      }, children), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
        cancelText: cancelText,
        confirmText: confirmText,
        ctaButtonRef: this.ctaButtonRef,
        description: description,
        isWorking: isWorking,
        onCancel: onCancel,
        onConfirm: onConfirm,
        ref: this.ctaButtonRef
      }), onClose ? /*#__PURE__*/_react.default.createElement(_ModalClose.default, {
        onClose: onClose,
        description: description
      }) : /*#__PURE__*/_react.default.createElement("div", null));
    }
  }]);
  return Modal;
}(_react.PureComponent);

Modal.defaultProps = {
  variant: 'informational',
  size: 'medium'
};
Modal.propTypes = {
  /** Optional: Query selector or DOM element identifying the root of your app */
  appElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),

  /** _Optional_ Cancel Text displayed on cancel button. `cancelText` must be accompanied by `onCancel`. */
  cancelText: _propTypes.default.string,

  /** Child content rendered inside Modal. */
  children: _propTypes.default.node,

  /** Optional: className to add to Modal */
  className: _propTypes.default.string,

  /** _Required_ Confirm Text displayed on main Confirm CTA button. `confirmText` must be accompanied by `onConfirm`. */
  confirmText: _propTypes.default.string.isRequired,

  /** _Required_ string to describe general modal functionality. It is recommended that the end user provide a `description` since it will be used in ARIA content. */
  description: _propTypes.default.string.isRequired,

  /** Displays Modal if `true`. */
  isOpen: _propTypes.default.bool,

  /** _Optional_ triggers working button if true  */
  isWorking: _propTypes.default.bool,

  /** _Required_ Name used for uniquely-labelling inner components of modal */
  name: _propTypes.default.string.isRequired,

  /** _Optional_ Controls visibility of cancel button and is called when cancel button is clicked. Displays cancelText. */
  onCancel: _propTypes.default.func,

  /** _Required_ event handler called when the modal is closed via close "X" icon in upper right corner.  */
  onClose: _propTypes.default.func.isRequired,

  /** _Required_ event handler called when the Confirm CTA is activated. Footer will only render if both `variant` and `onConfirm` are declared. `onConfirm` must be accompanied by `confirmText`. */
  onConfirm: _propTypes.default.func.isRequired,

  /** _Optional_ prop that sets the size of modal; supports `[medium|large]`; default is `medium`. `size` can be used in conjunction with any `variant`. */
  size: _propTypes.default.oneOf(['medium', 'large']),

  /** _Required_ Title text displayed in the modal header. */
  titleText: _propTypes.default.string.isRequired,

  /** _Optional_ prop that sets variant style for error, success, and warning messages; supports `[informational(default)|error|success|warning]`. */
  variant: _propTypes.default.oneOf(['informational', 'error', 'success', 'warning'])
};
var _default = Modal;
exports.default = _default;
//# sourceMappingURL=Modal.js.map